export const GAME_INFO = {
    countCardsOnStartP:     2,
    countCardsOnStartD:     1,
};

Object.defineProperty(GAME_INFO, "countCardsOnStartAll", {
    get: function() {
        return this.countCardsOnStartP + this.countCardsOnStartD;
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/common/game.js
// module id = 32
// module chunks = 0